import React, { useContext, useEffect } from "react";
import {
  ManagePlanLayout,
  CsplTable as Table,
  AddPlans,
  LoaderWrapper,
} from "../../../components";
import { isEmpty, get } from "lodash";
import { Link } from "react-router-dom";
import {
  getPathWithParam,
  getAdvancedPathWithParam,
  MANAGE_PLAN_ROUTES,
  FLOW_TYPES,
} from "../../../utils";
import { listSponsor } from "../../../services";
import { useRouterParams, useRequest } from "../../../abstracts";
import { createPlanStore, setManagePlanFlow } from "../../../contexts";
import AddToolTip from "../../../components/AddToolTip";

const columns = [
  {
    label: "Sponsor Company Name",
    className: "column-custodianName",
    columnName: "trusteeCompanyName",
  },
  {
    label: "Email",
    className: "column-custodianMail",
    columnName: "email",
  },
  {
    label: "Phone Number",
    className: "column-custodianPhone",
    columnName: "mobilePhoneNumber",
  },
];

const SponsorInformationContainer = (props) => {
  const { state, dispatch } = useContext(createPlanStore);
  const { planId } = useRouterParams();
  const { response: data, loading: load } = useRequest({
    method: listSponsor,
    payload: parseInt(planId),
    defaultResponse: [],
  });

  const sponsorData = get(data, "sponsors", []);
  const onAddClick = () => {
    const { history } = props;

    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_SPONSOR,
        pathParam: [FLOW_TYPES.ADD, planId, 0],
      })
    );
  };
  const buttons = [
    {
      label: "Add",
      variant: "primary",
      type: "button",
      // flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
      onClick: onAddClick,
    },
    // {
    //   label: "Add Sponsor",
    //   variant: "primary",
    //   type: "button",
    //   onClick: onAddClick,
    //   isAddButton: true,
    // },
  ];

  return (
    <LoaderWrapper isLoading={load}>
      <ManagePlanLayout buttons={buttons}>
        {isEmpty(sponsorData) && (
          <AddPlans
            menu="plan"
            subMenu="sponsor"
            content={
              <>
                No sponsors have been
                <br />
                created for this plan.
              </>
            }
            buttonLabel="Add Sponsor"
            link={getAdvancedPathWithParam({
              path: MANAGE_PLAN_ROUTES.ADD_SPONSOR,
              pathParam: [FLOW_TYPES.ADD, planId, 0],
            })}
          />
        )}
        {!isEmpty(sponsorData) && (
          <div className="w-100">
            <div className="d-flex w-100 align-items-center justify-content-between mb-4">
              <div className="m-0 plan-heading">Sponsor Information</div>
            </div>
            <Table>
              <Table.Thead>
                <Table.Tr>
                  {columns.map((item, index) => {
                    return (
                      <Table.Th key={index} className={item.className}>
                        {item.label}
                      </Table.Th>
                    );
                  })}
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {sponsorData.map((sponsor, index) => {
                  return (
                    <Table.Tr key={index}>
                      <Table.Td className="column-custodianName">
                        <Link
                          to={getPathWithParam({
                            path: MANAGE_PLAN_ROUTES.ADD_SPONSOR,
                            pathParam: [FLOW_TYPES.EDIT, planId, sponsor.id],
                          })}
                          style={{ width: "100%" }}
                        >
                          <AddToolTip
                            name={`${sponsor.name.firstName}  ${sponsor.name.lastName}`}
                          />
                        </Link>
                      </Table.Td>
                      <Table.Td className="column-custodianMail">
                        <AddToolTip name={sponsor.contactDetails.email} />
                      </Table.Td>
                      <Table.Td className="column-custodianPhone">
                        {sponsor.contactDetails.mobilePhoneNumber}
                      </Table.Td>
                    </Table.Tr>
                  );
                })}
              </Table.Tbody>
            </Table>
          </div>
        )}
      </ManagePlanLayout>
    </LoaderWrapper>
  );
};

export default SponsorInformationContainer;
